import { useEffect, useState } from "react";
import "./TextAreaComponent.scss";
import { color } from "@mui/system";

export const TextAreaComponent = ({
  name,
  value,
  onChange,
  label,
  placeHolder,
  styles,
  resize = "none",
  disabled = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [areaValue , setAreaValue] = useState(value)
  const shouldFloat = isFocused || (areaValue && areaValue.trim() !== "");

  const handleTextAreaOnChange = () => {
    const dataToEmmit = {
      target: {
        name: name ?? "",
        value: areaValue,
      },
    };
    onChange?.(dataToEmmit);
  };

  useEffect(()=>{
    handleTextAreaOnChange()
  } , [areaValue])
  return (
    <div className="text-area-component">
      {label && (
        <label
          className=""
          style={{
            position: "absolute",
            left: "var(--input-padding)",
            top: shouldFloat ? "-.9rem" : ".5rem",
            // transform: shouldFloat ? "translateY(0)" : "translateY(-50%)",
            fontSize: shouldFloat ? "var(--input-active-label-font-size)" : "var(--input-font-size)",
            color: shouldFloat ? "var(--grey-500)" : "var(--grey-250)",
            pointerEvents: "none",
            transition: "var(--transition)",
            backgroundColor:"transparent",
            padding: shouldFloat ? "0 4px" : "0",
          }}
        >
          {label}
        </label>
      )}
      <textarea
        style={{
            ...styles,
          resize: resize,
          backgroundColor : disabled ? "var(--disabled-input-bg)" : "",
          color : disabled ? "var(--grey-500)" : "var(--black)"
        }}

        disabled={disabled}
        className="text-area-component-textArea"
        name={name ?? ""}
        value={areaValue}
        onChange={(e)=>{setAreaValue(e.target.value)}}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      ></textarea>
    </div>
  );
};
